import { render } from "./PickTextTemplateModal.vue?vue&type=template&id=0906ff36&scoped=true"
import script from "./PickTextTemplateModal.vue?vue&type=script&lang=js"
export * from "./PickTextTemplateModal.vue?vue&type=script&lang=js"

import "./PickTextTemplateModal.vue?vue&type=style&index=0&id=0906ff36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0906ff36"]])

export default __exports__